<template>
<div class="chapter">
<div class="inner_page">
<div>
<a id="page_xxxiii"></a>
<p class="fmtitle"><i>Acknowledgements</i></p>
<p class="noindent">The authors are grateful to Graham Hopner of West Dunbartonshire Libraries for his help with Neil Munro’s biography. Our thanks are also due to David Harvie for his contribution to this section and for other advice and encouragement, and to Jessie MacLeod for her help and advice on matters Gaelic.</p>
<a id="page_xxxiv"></a>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 011_Acknowledgements.vue?6087b398